import { render } from "./EditProfileForm.vue?vue&type=template&id=7f44a15d&scoped=true"
import script from "./EditProfileForm.vue?vue&type=script&lang=js"
export * from "./EditProfileForm.vue?vue&type=script&lang=js"

import "./EditProfileForm.vue?vue&type=style&index=0&id=7f44a15d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f44a15d"]])

export default __exports__